import { RefObject, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { backofficeUrl } from '../helpers';

const ACTIVATE_ADDON_MESSAGE = 'ACTIVATE_ADDON';

const isAddonActivationMessage = (data: unknown): data is { type: typeof ACTIVATE_ADDON_MESSAGE; addon: string } => {
    if (!data || typeof data !== 'object') {
        return false;
    }

    const message = data as { type?: unknown; addon?: unknown };
    return message.type === ACTIVATE_ADDON_MESSAGE && typeof message.addon === 'string';
};

export const useAutoAddonActivation = (iframeRef: RefObject<HTMLIFrameElement>, enabled = true) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const onMessage = (event: MessageEvent) => {
            if (!iframeRef.current || event.source !== iframeRef.current.contentWindow || !isAddonActivationMessage(event.data)) {
                return;
            }

            const params = new URLSearchParams({
                tab: 'subscriptions',
                triggerAddonActivationFor: event.data.addon,
                redirectURLAfterActivation: window.location.href
            });

            navigate(`${backofficeUrl('/User/')}?${params.toString()}`);
        };

        window.addEventListener('message', onMessage);
        return () => window.removeEventListener('message', onMessage);
    }, [enabled, iframeRef, navigate]);
};
